<template>
  <div class="cq-config">
    <Spin fix v-if="pageLoading" />
    <div class="cq-config-main">
      <!-- 查询条件配置 -->
      <div class="cq-panel">
        <div class="cq-panel-head cq-center">
          <div class="cq-panel-title-wrap">
            <!-- <span class="cq-panel-title"><span class="required">*</span>查询条件配置</span> -->
            <p class="cq-panel-title"><span class="required">*</span>查询模板名称:&nbsp;&nbsp;<Input style="width: 200px;"
                v-model="templateName" placeholder="请输入查询模板名称" /></p>

          </div>
          <div>
            <Button type="primary" size="small" @click="openSortModal">数据排序</Button>&nbsp;
            <Button type="primary" size="small" @click="lookScript">查看脚本</Button>&nbsp;
            <Button type="primary" size="small" @click="addCondition">增&nbsp;行</Button>
          </div>
        </div>

        <div class="cq-panel-body">
          <table class="cq-table">
            <thead>
              <tr>
                <th style="width: 20%">主表名称</th>
                <th style="width: 20%">主表字段</th>
                <th style="width: 10%">运算关系</th>
                <th style="width: 30%">字段值</th>
                <th style="width: 10%">且/或关系</th>
                <th style="width: 10%">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in conditions" :key="index">
                <td>
                  <Select v-model="row.tableName" placeholder="请选择" filterable @on-change="onTableChange(row)" transfer>
                    <Option v-for="t in tableOptionsFor(index)" :value="t.name" :key="t.name">{{ t.label }}</Option>
                  </Select>
                </td>
                <td>
                  <Select v-model="row.fieldName" placeholder="请选择" filterable @on-change="onFieldChange(row)" transfer>
                    <!-- 字段名可能重复，name+index 兜底避免 duplicate key 警告 -->
                    <Option v-for="(f, fIdx) in (fieldsMap[row.tableName] || [])" :value="f.name"
                      :key="f.name + '_' + fIdx">{{ f.label }}</Option>
                  </Select>
                </td>
                <td>
                  <Select v-model="row.op" placeholder="请选择" filterable transfer>
                    <Option v-for="o in operatorsForRow(row)" :value="o.value" :key="o.value">{{ o.label }}</Option>
                  </Select>
                </td>
                <td>
                  <template v-if="valueControlType(row) === 'dic' && row.dicType == '0'">
                    <div v-if="isMultiDic(row) && row._multiDicVals" class="cq-multi-dic">
                      <div class="cq-multi-dic-item">
                        <!-- <span class="cq-multi-dic-label">{{ fieldDicNameList(row)[0] }}</span> -->
                        <s-dicgrid v-model="row._multiDicVals[0]" :multiple="row.isDicMultiple == '1'"
                          :dicName="fieldDicNameList(row)[0]" style="flex: 1" />
                      </div>
                      <template v-if="row._multiDicExpand">
                        <div v-for="(dn, di) in fieldDicNameList(row).slice(1)" :key="dn" class="cq-multi-dic-item">
                          <!-- <span class="cq-multi-dic-label">{{ dn }}</span> -->
                          <s-dicgrid v-model="row._multiDicVals[di + 1]" :multiple="row.isDicMultiple == '1'"
                            :dicName="dn" style="flex: 1" />
                        </div>
                      </template>
                      <a class="cq-multi-dic-toggle" @click="toggleMultiDic(row)">
                        {{ row._multiDicExpand ? '收起' : ('展开全部（共' + fieldDicNameList(row).length + '项）') }}
                      </a>
                    </div>
                    <s-dicgrid v-else v-model="row.value" :multiple="row.isDicMultiple == '1' ? true : false"
                      :dicName="fieldDicName(row)" style="width: 100%" />
                  </template>
                  <Select filterable v-else-if="valueControlType(row) === 'dic' && row.dicType == '3'"
                    v-model="row.value" style="width: 100%;text-align: left;"
                    :multiple="row.isDicMultiple == '1' ? true : false" clearable placeholder="请选择">
                    <Option v-for="itemDic in parseDicInfo(row.dicInfo)" :value="itemDic.key" :key="itemDic.key">{{
                      itemDic.text }}
                    </Option>
                  </Select>
                  <el-date-picker v-else-if="valueControlType(row) === 'datetime'"
                    :format="row.format ? row.format : 'yyyy-MM-dd HH:mm:ss'"
                    :value-format="row.format ? row.format : 'yyyy-MM-dd HH:mm:ss'" v-model="row.value"
                    placeholder="请选择" size="small" style="width: 100%" />
                  <el-date-picker v-else-if="valueControlType(row) === 'date'" type="date"
                    :format="row.format ? row.format : 'yyyy-MM-dd'"
                    :value-format="row.format ? row.format : 'yyyy-MM-dd'" v-model="row.value" placeholder="请选择"
                    size="small" style="width: 100%" />
                  <el-time-picker v-else-if="valueControlType(row) === 'time'"
                    :format="row.format ? row.format : 'HH:mm:ss'" :value-format="row.format ? row.format : 'HH:mm:ss'"
                    v-model="row.value" placeholder="请选择" size="small" style="width: 100%" />
                  <InputNumber v-else-if="valueControlType(row) === 'number'" v-model="row.value" placeholder="请输入"
                    style="width: 100%" />
                  <Input v-else v-model="row.value" placeholder="请输入" />
                </td>
                <td>
                  <Select v-model="row.logic" placeholder="请选择" filterable transfer>
                    <Option v-for="l in logicOps" :value="l.value" :key="l.value">{{ l.label }}</Option>
                  </Select>
                </td>
                <td class="cq-op-cell">
                  <a v-if="index > 0" class="cq-del" @click="removeCondition(index)">删除</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 列表表头配置 -->
      <div class="cq-panel">
        <div class="cq-panel-head">
          <span class="cq-panel-title"><span class="required">*</span>列表表头配置</span>
          <span class="cq-panel-tip">请先选择数据主表，然后勾选您希望在查询表格中展示的字段。</span>
          <Checkbox v-if="headerFields.length > 0" :value="checkAll" :indeterminate="checkAllIndeterminate"
            class="cq-check-all" @on-change="onCheckAllChange">全选</Checkbox>
        </div>
        <div class="cq-panel-body">
          <CheckboxGroup v-model="checkedFields" class="cq-field-group">
            <!-- 字段名可能重复（后端偶发同名字段），用 name+index 兜底避免 duplicate key 警告 -->
            <Checkbox v-for="(f, idx) in headerFields" :key="f.name + '_' + idx" :label="f.name" class="cq-field-item">
              {{
                f.label }}</Checkbox>
          </CheckboxGroup>
          <p v-if="headerFields.length === 0" class="cq-empty-tip">请先在查询条件中选择主表</p>
        </div>
      </div>
    </div>
    <!-- 底部操作 -->
    <div class="cq-footer">
      <div class="cq-footer-btns">
        <Button type="primary" @click="$emit('open-history')">历史查询模版</Button>
        <Button type="primary" @click="openSaveModal">保存为查询模版</Button>
        <Button type="primary" @click="execute">执行查询</Button>
      </div>
    </div>

    <!-- 保存为查询模版 -->
    <save-template-modal v-model="saveModalShow" :api="api" :payload="savePayload" @saved="onTemplateSaved" />
    <!-- 查看脚本 -->
    <script-modal v-model="scriptModalShow" :api="api" :query-json="scriptQueryJson" :app-id="resolvedAppId" />

    <!-- 数据排序弹窗 -->
    <Modal v-model="sortModalShow" title="数据排序" width="900" :mask-closable="false">
      <div class="cq-sort-tip">请设置查询结果排序规则，支持多字段排序（先按第一个字段排序，再按第二个……），可拖拽行调整顺序</div>
      <Table border :height="400" :columns="sortColumns" :data="sortRows" stripe :no-data-text="'暂未配置排序'"
        class="cq-sort-table" :draggable="true" @on-drag-drop="onSortDragDrop">
        <template slot-scope="{ row, index }" slot="tableName">
          <Select :value="row.tableName" placeholder="请选择" filterable transfer
            @on-change="v => { $set(sortRows[index], 'tableName', v); $set(sortRows[index], 'fieldName', '') }">
            <Option v-for="t in mainTables" :value="t.name" :key="t.name">{{ t.label }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="fieldName">
          <Select :value="row.fieldName" placeholder="请选择" filterable transfer
            @on-change="v => { $set(sortRows[index], 'fieldName', v) }">
            <Option v-for="(f, fIdx) in (fieldsMap[row.tableName] || [])" :value="f.name" :key="f.name + '_' + fIdx">{{
              f.label }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="sortType">
          <Select :value="row.sortType" placeholder="请选择" transfer
            @on-change="v => { $set(sortRows[index], 'sortType', v) }">
            <Option value="asc" key="asc">升序（asc）</Option>
            <Option value="desc" key="desc">降序（desc）</Option>
          </Select>
        </template>
        <template slot-scope="{ index }" slot="action">
          <a class="cq-del" @click="removeSortRow(index)">删除</a>
        </template>
      </Table>
      <div style="margin-top: 10px;">
        <Button type="dashed" long icon="md-add" @click="addSortRow">新增排序</Button>
      </div>
      <div slot="footer">
        <Button @click="cancelSort">取消</Button>
        <Button type="primary" @click="confirmSort">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import saveTemplateModal from '../components/save-template-modal.vue'
import scriptModal from '../components/script-modal.vue'

export default {
  name: 'query-config',
  components: {
    saveTemplateModal,
    scriptModal
  },
  props: {
    api: {
      type: Object,
      required: true
    },
    mark: {
      type: String,
      default: ''
    },
    // 编辑回填模版 id
    templateId: {
      type: String,
      default: ''
    },
    // 编辑回填模版名称（来自历史模版）
    editTemplateName: {
      type: String,
      default: ''
    },
    // 应用ID（外部传入，回退到全局 serverConfig.APP_ID）
    appId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageLoading: false,
      templateName: '',
      remark: '',
      mainTables: [],
      logicOps: [],
      // 运算关系：字符串类型(varchar/text)用 strOpList，其余用 opNameList（对齐 model-query-form.vue）
      opNameList: [
        { value: '!=', label: '!=' },
        { value: '<=', label: '<=' },
        { value: '<', label: '<' },
        { value: '>=', label: '>=' },
        { value: '>', label: '>' },
        { value: '=', label: '=' },
        { value: 'between', label: 'between' }
      ],
      strOpList: [
        { value: '=', label: '精确匹配' },
        { value: 'like', label: '模糊匹配' },
        { value: 'in', label: 'IN查询' },
        { value: 'between', label: 'between' },
        { value: 'join', label: 'sql脚本' }
      ],
      fieldsMap: {}, // { tableName: [fields] }
      conditions: [],
      checkedFields: [],
      checkAll: false, // 表头字段全选状态（默认不勾选）
      checkAllIndeterminate: false, // 表头字段半选状态
      saveModalShow: false,
      savePayload: {},
      scriptModalShow: false, // 查看脚本弹窗
      scriptQueryJson: null, // 传给脚本弹窗的查询配置
      // 数据排序
      sortModalShow: false,
      sortRows: [],
      orderObj: { sortName: '', sortType: '' },
      // 运算符 -> 中文说明（用于拼接查询条件的中文内容 queryCondition，对齐后端 operators 标签）
      opCnMap: {
        '=': '等于',
        '!=': '不等于',
        '>': '大于',
        '>=': '大于等于',
        '<': '小于',
        '<=': '小于等于',
        like: '包含',
        leftLike: '左匹配',
        rightLike: '右匹配',
        in: '包含于',
        notIn: '不包含于',
        between: '介于',
        isNull: '为空',
        isNotNull: '不为空',
        join: 'SQL脚本'
      },
    }
  },
  computed: {
    // 解析后的 appId：优先取 prop，其次全局 serverConfig.APP_ID（与 data 中 appId 同名会导致 Vue 警告）
    resolvedAppId() {
      return this.appId || (typeof serverConfig !== 'undefined' && serverConfig && serverConfig.APP_ID) || ''
    },
    // 当前查询主表（单表查询：以第一行为准）
    mainTableName() {
      return this.conditions.length && this.conditions[0].tableName ? this.conditions[0].tableName : ''
    },
    // 表头字段：取当前条件中第一个已选主表的字段
    headerFields() {
      let tableName = ''
      for (let i = 0; i < this.conditions.length; i++) {
        if (this.conditions[i].tableName) {
          tableName = this.conditions[i].tableName
          break
        }
      }
      return tableName ? this.fieldsMap[tableName] || [] : []
    },
    // 排序弹窗 Table 列定义（纯 slot，值通过模板 v-model 响应式绑定）
    sortColumns() {
      return [
        {
          title: '序号', width: 70, align: 'center', slot: '_sortIndex',
          render: (h, { index }) => h('span', index + 1)
        },
        { title: '主表名称', width: 200, slot: 'tableName' },
        { title: '主表字段', slot: 'fieldName' },
        { title: '排序方式', width: 200, slot: 'sortType' },
        { title: '操作', width: 70, align: 'center', slot: 'action' }
      ]
    }
  },
  watch: {
    // 已勾选字段变化时，同步全选/半选状态
    checkedFields() {
      this.updateCheckAllState()
    },
    // 主表变化导致表头字段变化时，剔除不在当前字段范围内的已勾选项并同步状态
    headerFields(fields) {
      let names = fields.map(f => f.name)
      let pruned = this.checkedFields.filter(n => names.indexOf(n) > -1)
      if (pruned.length !== this.checkedFields.length) {
        this.checkedFields = pruned
      }
      this.updateCheckAllState()
    }
  },
  created() {
    // 查询模板名称默认取当前日期
    this.templateName = this.formatToday()
    this.initData()
  },
  methods: {
    // 生成当前日期时间字符串（yyyy-MM-dd HH:mm:ss）
    formatToday() {
      let d = new Date()
      let m = String(d.getMonth() + 1).padStart(2, '0')
      let day = String(d.getDate()).padStart(2, '0')
      let hh = String(d.getHours()).padStart(2, '0')
      let mi = String(d.getMinutes()).padStart(2, '0')
      let ss = String(d.getSeconds()).padStart(2, '0')
      return d.getFullYear() + m + day + hh + mi + ss
    },
    initData() {
      this.pageLoading = true
      Promise.all([this.api.getMainTables(this.resolvedAppId), this.api.getLogicOps()]).then(([tables, logics]) => {
        this.mainTables = tables
        this.logicOps = logics
        if (this.templateId) {
          this.loadTemplate()
        } else {
          this.addCondition()
          this.pageLoading = false
        }
      }).catch(() => {
        this.pageLoading = false
        this.addCondition()
      })
    },
    loadTemplate() {
      // 编辑时，保存模板名默认回填为当前模板名
      if (this.editTemplateName) {
        this.templateName = this.editTemplateName
      }
      this.api.getTemplateDetail(this.templateId, this.editTemplateName).then(detail => {
        if (!detail) {
          this.addCondition()
          this.pageLoading = false
          return
        }
        console.log('loadTemplate detail:', detail)
        // 模板名优先取详情返回值
        if (detail.name) {
          this.templateName = detail.name
        }
        if (detail.remark) {
          this.remark = detail.remark
        }
        // 回显排序
        this.orderObj.sortName = detail.sortName || ''
        this.orderObj.sortType = detail.sortType || ''
        let mainTableName = detail.mainTableName
        if (!mainTableName) {
          this.addCondition()
          this.pageLoading = false
          return
        }
        // 主表字段：优先用详情已带回的字段，避免再次请求；否则回退按主表名拉取
        let fieldsReady
        if (detail.fields && detail.fields.length) {
          this.$set(this.fieldsMap, mainTableName, detail.fields)
          fieldsReady = Promise.resolve()
        } else {
          fieldsReady = this.loadFields(mainTableName)
        }
        fieldsReady.then(() => {
          // 回填查询条件行（字段/运算符/字段值/且或关系 + 扩展字段）
          let rows = (detail.conditions || []).map(c => ({
            tableName: mainTableName,
            fieldName: c.fieldName || '',
            op: c.op || '',
            value: c.value !== undefined ? c.value : '',
            logic: String(c.relation || c.logic || 'and').toLowerCase(),
            format: c.format || '',
            isDicMultiple: c.isDicMultiple !== undefined ? c.isDicMultiple : '',
            dicType: c.dicType || '',
            dicInfo: c.dicInfo || ''
          }))
          this.conditions = rows.length
            ? rows
            : [{ tableName: mainTableName, fieldName: '', op: '', value: '', logic: 'and' }]
          // 多字典行初始化独立值数组
          this.$nextTick(() => {
            this.conditions.forEach(r => {
              if (this.isMultiDic(r)) {
                this.ensureMultiDicVals(r)
              }
            })
          })
          // 回填已勾选的表头字段
          this.checkedFields = (detail.showFields || []).slice()
          this.pageLoading = false
        })
      }).catch(err => {
        console.error('[query-config] 加载模板详情失败:', err)
        this.$Message.error('加载模板详情失败，请稍后重试')
        this.addCondition()
        this.pageLoading = false
      })
    },
    loadFields(tableName) {
      if (this.fieldsMap[tableName]) {
        return Promise.resolve(this.fieldsMap[tableName])
      }
      return this.api.getTableFields(tableName).then(fields => {
        this.$set(this.fieldsMap, tableName, fields)
        return fields
      })
    },
    // 某行主表下拉可选项：未选主表或首行时可选全部；已选主表后其余行仅显示该主表（单表限制，多表后续扩展）
    tableOptionsFor(index) {
      let main = this.mainTableName
      if (!main || index === 0) {
        return this.mainTables
      }
      let t = this.mainTables.find(x => x.name === main)
      return t ? [t] : this.mainTables
    },
    onTableChange(row) {
      // 单表查询：主表变化时同步所有行到同一主表，并清空各行字段/值/运算符
      this.conditions.forEach(r => {
        r.tableName = row.tableName
        r.fieldName = ''
        r.value = ''
        r.op = ''
      })
      if (row.tableName) {
        this.loadFields(row.tableName)
      }
    },
    // 切换字段后清空已填字段值和运算符（类型变化后可选运算符不同）
    onFieldChange(row) {
      row.value = ''
      row.op = ''
      // 清除旧的多字典数据
      delete row._multiDicVals
      delete row._multiDicExpand
      // 从字段元信息中同步扩展字段
      let field = this.findField(row)
      if (field) {
        this.$set(row, 'format', field.format || '')
        this.$set(row, 'isDicMultiple', field.isDicMultiple !== undefined ? field.isDicMultiple : '')
        this.$set(row, 'dicType', field.dicType || '')
        this.$set(row, 'dicInfo', field.dicInfo || '')
      } else {
        this.$set(row, 'format', '')
        this.$set(row, 'isDicMultiple', '')
        this.$set(row, 'dicType', '')
        this.$set(row, 'dicInfo', '')
      }
      // 多字典时初始化 _multiDicVals
      if (this.isMultiDic(row)) {
        this.ensureMultiDicVals(row)
      }
    },
    // 根据所选字段的 fieldType 返回可选运算关系：varchar/text 用 strOpList，其余用 opNameList
    operatorsForRow(row) {
      let field = this.findField(row)
      let type = field && field.fieldType ? String(field.fieldType).toLowerCase() : ''
      if (type === 'varchar' || type === 'text') {
        return this.strOpList
      }
      return this.opNameList
    },
    // 根据所选字段的 fieldType 推断字段值应使用的控件类型
    valueControlType(row) {
      let field = this.findField(row)
      if (!field) {
        return 'text'
      }
      let type = field.fieldType ? String(field.fieldType).toLowerCase() : ''
      if (type === 'timestamp' || type === 'datetime') {
        return 'datetime'
      }
      if (type === 'date') {
        return 'date'
      }
      if (type === 'time') {
        return 'time'
      }
      if (['number', 'int', 'integer', 'bigint', 'decimal', 'double', 'float', 'numeric', 'long'].indexOf(type) > -1) {
        return 'number'
      }
      // 文本类型（varchar 等）且配置了字典时，使用字典组件
      if (field.dicName || field.dicInfo) {
        return 'dic'
      }
      return 'text'
    },
    // 取某行所选字段对象
    findField(row) {
      if (!row.tableName || !row.fieldName) {
        return null
      }
      let fields = this.fieldsMap[row.tableName] || []
      return fields.find(f => f.name === row.fieldName) || null
    },
    // 取某行所选字段的字典标识
    fieldDicName(row) {
      let field = this.findField(row)
      return field ? field.dicName || '' : ''
    },
    // 判断是否为多字典（逗号分隔）
    isMultiDic(row) {
      let dicName = this.fieldDicName(row)
      return dicName && dicName.indexOf(',') > -1
    },
    // 拆解逗号分隔的字典名列表
    fieldDicNameList(row) {
      let dicName = this.fieldDicName(row)
      return dicName ? dicName.split(',').map(s => s.trim()).filter(Boolean) : []
    },
    // 切换多字典展开/收起
    toggleMultiDic(row) {
      this.$set(row, '_multiDicExpand', !row._multiDicExpand)
    },
    // 初始化多字典独立值（从 row.value 复制给每个字典作为初始值）
    ensureMultiDicVals(row) {
      if (!row._multiDicVals) {
        let list = this.fieldDicNameList(row)
        this.$set(row, '_multiDicVals', list.map(() => row.value || ''))
      }
    },
    // 将多字典独立值拼回 row.value（构建 queryJson 前调用）
    mergeMultiDicVals(row) {
      if (row._multiDicVals) {
        let vals = row._multiDicVals.filter(v => v)
        this.$set(row, 'value', vals.join(','))
      }
    },
    // 解析自定义字典 dicInfo JSON 字符串，转为 [{key, text}] 格式
    parseDicInfo(dicInfo) {
      if (!dicInfo) return []
      try {
        let obj = typeof dicInfo === 'string' ? JSON.parse(dicInfo) : dicInfo
        return Object.keys(obj).map(k => ({ key: k, text: obj[k] }))
      } catch (e) {
        return []
      }
    },
    addCondition() {
      // 单表查询：新增行默认沿用已选主表
      let main = this.mainTableName
      this.conditions.push({ tableName: main || '', fieldName: '', op: '', value: '', logic: 'and', format: '', isDicMultiple: '', dicType: '', dicInfo: '' })
      if (main) {
        this.loadFields(main)
      }
    },
    removeCondition(index) {
      this.conditions.splice(index, 1)
    },
    // ===== 数据排序 =====
    openSortModal() {
      if (!this.mainTableName) {
        this.$Message.warning('请先选择主表')
        return
      }
      let names = this.orderObj.sortName ? this.orderObj.sortName.split(',') : []
      let types = this.orderObj.sortType ? this.orderObj.sortType.split(',') : []
      // 用 splice 清空 + push 逐个添加，确保响应式
      this.sortRows.splice(0, this.sortRows.length)
      names.forEach((n, i) => {
        this.sortRows.push({
          tableName: this.mainTableName,
          fieldName: n.trim(),
          sortType: (types[i] || 'asc').trim()
        })
      })
      this.sortModalShow = true
    },
    addSortRow() {
      this.sortRows.push({ tableName: this.mainTableName, fieldName: '', sortType: 'asc' })
    },
    removeSortRow(index) {
      this.sortRows.splice(index, 1)
    },
    cancelSort() {
      this.sortModalShow = false
      this.sortRows.splice(0, this.sortRows.length)
    },
    confirmSort() {
      let valid = this.sortRows.filter(r => r.tableName && r.fieldName && r.sortType)
      this.orderObj.sortName = valid.map(r => r.fieldName).join(',')
      this.orderObj.sortType = valid.map(r => r.sortType).join(',')
      this.sortModalShow = false
      this.$Message.success('排序设置已更新')
    },
    // 拖拽排序行
    onSortDragDrop(index1, index2) {
      let row = this.sortRows.splice(index1, 1)[0]
      this.sortRows.splice(index2, 0, row)
    },
    // ===== 数据排序 END =====
    // 表头字段全选/取消全选
    onCheckAllChange(checked) {
      this.checkedFields = checked ? this.headerFields.map(f => f.name) : []
    },
    // 根据已勾选数量刷新全选框的选中/半选状态
    updateCheckAllState() {
      let total = this.headerFields.length
      let names = this.headerFields.map(f => f.name)
      let checked = names.filter(n => this.checkedFields.indexOf(n) > -1).length
      this.checkAll = total > 0 && checked === total
      this.checkAllIndeterminate = checked > 0 && checked < total
    },
    validate() {
      let validRows = this.conditions.filter(r => r.tableName && r.fieldName && r.op)
      if (validRows.length < 1) {
        this.$Message.error('至少要有1行完整的【查询条件配置】')
        return false
      }
      if (this.checkedFields.length < 3) {
        this.$Message.error('需配置表头字段至少3个')
        return false
      }
      return true
    },
    // 取主表对应的 tableId（resId）
    tableIdOf(tableName) {
      let t = this.mainTables.find(x => x.name === tableName)
      return t ? t.resId || t.name : tableName
    },
    // 构建后端所需的 queryJson 结构
    buildQueryJson() {
      // 多字典行：构建前将独立值合并回 row.value
      this.conditions.forEach(r => {
        if (this.isMultiDic(r)) {
          this.mergeMultiDicVals(r)
        }
      })
      let firstTableRow = this.conditions.find(r => r.tableName)
      let conditions = this.conditions
        .filter(r => r.tableName && r.fieldName)
        .map(r => ({
          fieldName: r.fieldName,
          op: r.op,
          value: r.value,
          relation: (r.logic || 'and').toUpperCase(),
          format: r.format || '',
          isDicMultiple: r.isDicMultiple || '',
          dicType: r.dicType || '',
          dicInfo: r.dicInfo || ''
        }))
      return {
        tableId: firstTableRow ? this.tableIdOf(firstTableRow.tableName) : '',
        showFields: this.checkedFields.slice(),
        conditions: conditions,
        sortName: this.orderObj.sortName || '',
        sortType: this.orderObj.sortType || ''
      }
    },
    buildPayload() {
      let fields = this.headerFields
      let showFields = this.checkedFields.map(name => {
        let f = fields.find(x => x.name === name)
        return { name: name, label: f ? f.label : name }
      })
      let opLabel = r => {
        let o = this.operatorsForRow(r).find(x => x.value === r.op)
        return o ? o.label : r.op
      }
      let conditionSummary = this.conditions
        .filter(r => r.tableName && r.fieldName)
        .map(r => {
          let f = (this.fieldsMap[r.tableName] || []).find(x => x.name === r.fieldName)
          return (f ? f.label : r.fieldName) + ' ' + opLabel(r) + ' "' + (r.value || '') + '"'
        })
      let firstTableRow = this.conditions.find(r => r.tableName)
      return {
        appId: this.resolvedAppId,
        mark: this.mark,
        mainTableName: firstTableRow ? firstTableRow.tableName : '',
        conditions: this.conditions.filter(r => r.tableName && r.fieldName),
        showFields: showFields,
        conditionSummary: conditionSummary,
        // 查询条件拼接的中文内容（保存模板时随参数上送）
        queryCondition: this.buildQueryCondition(),
        queryJson: this.buildQueryJson()
      }
    },
    // 字段值转展示文本：多字典翻译中文名，数组按「起 ~ 止」拼接，其余原样
    conditionValueText(row) {
      // 多字典：展示中文名
      if (this.isMultiDic(row) && row._multiDicVals) {
        let list = this.fieldDicNameList(row)
        return row._multiDicVals.map((v, i) => {
          let name = list[i] || ''
          let text = this.translateDicValue(name, v)
          return name ? name + ':' + text : text
        }).filter(Boolean).join('；')
      }
      // 单字典或自定义字典
      if (this.valueControlType(row) === 'dic' && row.dicType === '0') {
        return this.translateDicValue(this.fieldDicName(row), row.value)
      }
      if (this.valueControlType(row) === 'dic' && row.dicType === '3' && row.dicInfo) {
        return this.translateCustomDicValue(row.dicInfo, row.value)
      }
      let v = row.value
      if (Array.isArray(v)) {
        return v.join(' ~ ')
      }
      return v === undefined || v === null ? '' : String(v)
    },
    // 翻译系统字典值：code → 中文名
    translateDicValue(dicName, value) {
      if (!value || !dicName) return value || ''
      let vals = String(value).split(',').map(s => s.trim()).filter(Boolean)
      return vals.map(v => this.getDicLabel(dicName, v)).join('、')
    },
    // 翻译自定义字典值：code → 中文名
    translateCustomDicValue(dicInfo, value) {
      if (!value || !dicInfo) return value || ''
      let vals = String(value).split(',').map(s => s.trim()).filter(Boolean)
      let items = this.parseDicInfo(dicInfo)
      return vals.map(v => {
        let item = items.find(x => x.key === v)
        return item ? item.text : v
      }).join('、')
    },
    // 从已加载的字典数据中取 label
    getDicLabel(_dicName, code) {
      return code
    },
    // 运算符中文说明
    opCnLabel(op) {
      return this.opCnMap[op] || op
    },
    // 且/或关系中文说明：优先取后端 logicOps 标签，兜底「且/或」
    logicCnLabel(logic) {
      let l = (this.logicOps || []).find(x => x.value === logic)
      if (l && l.label) {
        return l.label
      }
      return logic === 'or' || logic === 'OR' ? '或' : '且'
    },
    // 拼接查询条件的中文内容，不同条件换行展示，形如：
    //   凭证日期 介于 "2024-01-01 ~ 2024-12-31"
    //   且 金额 大于 "10,000"
    buildQueryCondition() {
      let rows = this.conditions.filter(r => r.tableName && r.fieldName && r.op)
      let lines = []
      rows.forEach((r, i) => {
        let f = (this.fieldsMap[r.tableName] || []).find(x => x.name === r.fieldName)
        let label = f ? f.label : r.fieldName
        let opCn = this.opCnLabel(r.op)
        // 为空/不为空无字段值
        let noValue = r.op === 'isNull' || r.op === 'isNotNull'
        let text = noValue ? label + ' ' + opCn : label + ' ' + opCn + ' "' + this.conditionValueText(r) + '"'
        // 从第二个条件起，用当前条件自身的且/或关系作为与上一条件的连接词（与上送后端的 relation 保持一致）
        if (i > 0) {
          text = this.logicCnLabel(r.logic) + ' ' + text
        }
        lines.push(text)
      })
      return lines.join('\n')
    },
    execute() {
      if (!this.validate()) {
        return
      }
      // 执行查询：不落库，直接携带 queryJson 跳转结果页拉取数据
      this.$emit('execute', this.buildPayload())
    },
    // 查看脚本：用当前配置构建 queryJson 打开脚本弹窗
    lookScript() {
      if (!this.validate()) {
        return
      }
      this.scriptQueryJson = this.buildQueryJson()
      this.scriptModalShow = true
    },
    openSaveModal() {
      if (!this.validate()) {
        return
      }
      this.savePayload = Object.assign(this.buildPayload(), {
        appId: this.resolvedAppId,
        id: this.templateId || '',
        remark: this.remark || '',
        templateName: this.templateName,
        queryJson: this.buildQueryJson()
      })
      this.saveModalShow = true
    },
    onTemplateSaved() {
      // 保存成功后停留在当前页
    }
  }
}
</script>

<style lang="less" scoped>
.cq-config {
  padding: 12px;
}

.cq-config-main {
  height: calc(~'100vh - 80px');
  overflow-y: auto;
}

.required {
  color: #ed4014;
  margin-right: 2px;
}

.cq-panel {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 12px;
  padding: 12px 16px 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.cq-panel-head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.cq-center {
  justify-content: space-between;
}

.cq-panel-title-wrap {
  display: flex;
  align-items: center;
}

.cq-panel-title {
  font-size: 15px;
  font-weight: 600;
}

.cq-check-all {
  margin-left: auto;
}

.cq-panel-tip {
  font-size: 12px;
  color: #999;
  margin-left: 12px;
}

.cq-panel-head .ivu-btn {
  margin-left: auto;
}

.cq-table {
  width: 100%;
  border-collapse: collapse;
}

.cq-table th,
.cq-table td {
  border: 1px solid #dcdee2;
  padding: 8px 10px;
  text-align: center;
}

.cq-table th {
  background: #bcd4ef;
  font-weight: 600;
  text-align: center;
  color: #17233d;
}

.cq-op-cell {
  text-align: center;
}

.cq-del {
  color: #ed4014 !important;
}

.cq-field-group {
  display: flex;
  flex-wrap: wrap;
}

.cq-field-item {
  width: 12.5%;
  margin: 8px 0;
  font-size: 14px;
}

.cq-empty-tip {
  color: #999;
  font-size: 13px;
  padding: 8px 0;
}

.cq-footer {
  background: #fff;
  border-radius: 4px;
  padding: 16px;
}

.cq-save-check {
  color: #ed4014;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
}

.cq-footer-btns {
  text-align: right;
}

.cq-footer-btns .ivu-btn {
  min-width: 110px;
  margin-left: 10px;
}

/* ===== 排序弹窗 ===== */
.cq-sort-tip {
  color: #808695;
  font-size: 13px;
  margin-bottom: 12px;
}

.cq-sort-table {
  margin-bottom: 0;
}

/* ===== 多字典 ===== */
.cq-multi-dic {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cq-multi-dic-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cq-multi-dic-label {
  font-size: 11px;
  color: #808695;
  white-space: nowrap;
  min-width: 60px;
  text-align: right;
}

.cq-multi-dic-toggle {
  font-size: 12px;
  color: #2b5fd9;
  cursor: pointer;
  user-select: none;
}

.cq-multi-dic-toggle:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/views/query-config.vue